export const createActionStateHelper = ({
  setShowAddButton,
  setShowSelectionButton,
}) => {
  const applySelectionAction = (column) => {
    if (column.selection) {
      let { isActive = false, action = [] } = column.selection
      setShowSelectionButton({ show: isActive, action: action })
    }
  }

  const showAddAction = (item) => {
    setShowAddButton({ show: item.isActive, action: item })
  }

  return {
    applySelectionAction,
    showAddAction,
  }
}
